import controller from './dropdown.controller';
import './dropdown.component.less';

export default {
  bindings: {
    list: '<',
    callFn: '<',
    defaultItem: '<?'
  },
  controller,
  template: require('./dropdown.html')
};



// WEBPACK FOOTER //
// src/app/components/dropdown/dropdown.component.ts